import {updateDates} from '../../../../commons/actions/dates'
import {getOrder, placeOrder, updateOrder} from '../actions/placed-order'

export const datesMiddleware = store => next => action => {
  switch (action.type) {
    case placeOrder.fulfilled.toString():
    case updateOrder.fulfilled.toString():
    case getOrder.fulfilled.toString(): {
      store.dispatch(updateDates(action.payload.dates))
      break
    }
    default:
      break
  }
  next(action)
}
